import React, { useState } from "react";
import "./Search.css";
import { useNavigate } from "react-router-dom";
const services = [
 {
    name: "Switchboard Repair / Replacement",
    path: "/Electrician"
  },
  {
    name: "Window AC Jet Service",
    path: "/Electrician"
  },
  {
    name: "New Switch Box Installation",
    path: "/Electrician"
  },
  {
    name: "Fan Repair",
    path: "/Electrician"
  },
  {
    name: "Exhaust / Pedestal / Tower Fan Installation",
    path: "/Electrician"
  },
  {
    name: "Fan Regulator Replacement",
    path: "/Electrician"
  },
  {
    name: "Karban Airzone Fan Installation",
    path: "/Electrician"
  },
  {
    name: "Fancy Light Installation / Replacement",
    path: "/Electrician"
  },
  {
    name: "Tubelight Installation",
    path: "/Electrician"
  },
  {
    name: "Bulb Installation",
    path: "/Electrician"
  },
  {
    name: "Ceiling Light Installation",
    path: "/Electrician"
  },
  {
    name: "Hanging Light Installation",
    path: "/Electrician"
  },
  {
    name: "Chandelier Installation",
    path: "/Electrician"
  },
  {
    name: "Internal Wiring (Per Meter)",
    path: "/Electrician"
  },
  {
    name: "External Wiring (Per Meter)",
    path: "/Electrician"
  },
  {
    name: "Regular Doorbell Installation",
    path: "/Electrician"
  },
  {
    name: "Video Doorbell Installation",
    path: "/Electrician"
  },
  {
    name: "MCB / Fuse Repair",
    path: "/Electrician"
  },
  {
    name: "Inverter Fuse Replacement",
    path: "/Electrician"
  },
  {
    name: "Sub Meter Installation",
    path: "/Electrician"
  },
  {
    name: "TV Installation",
    path: "/Electrician"
  },
  {
    name: "TV Uninstallation",
    path: "/Electrician"
  },
  {
    name: "Inverter Installation",
    path: "/Electrician"
  },
  {
    name: "Inverter Fuse Replacement",
    path: "/Electrician"
  },
  {
    name: "Inverter Servicing",
    path: "/Electrician"
  },
  {
    name: "Inverter Check-up",
    path: "/Electrician"
  },
  {
    name: "Inverter Uninstallation",
    path: "/Electrician"
  },
  {
    name: "Stabilizer Installation",
    path: "/Electrician"
  },
  {
    name: "Sub Category",
    path: "/Electrician"
  },
  {
    name: "Decorative Fan Installation",
    path: "/Electrician"
  },
  {
    name: "Regular Ceiling Fan Installation",
    path: "/Electrician"
  },
  {
    name: "Smart / BLDC Fan Installation",
    path: "/Electrician"
  },
  {
    name: "Sound Bar Installation",
    path: "/Electrician"
  },
  //2nd component
  {
    name: "Tap Leakage Repair",
    path: "/Plumber"
  },
  {
    name: "Tap accessory installation",
    path: "/Plumber"
  },
  {
    name: "Tap installation/replacement",
    path: "/Plumber"
  },
  {
    name: "Wash Basin Installation",
    path: "/Plumber"
  },
  {
    name: "Tap Installation",
    path: "/Plumber"
  },
  {
    name: "Hand Shower Installation",
    path: "/Plumber"
  },
  {
    name: "Wash Basin Block Removal",
    path: "/Plumber"
  },
  {
    name: "Bathroom Drain Block Removal",
    path: "/Plumber"
  },
  {
    name: "Kitchen Drain Block Removal",
    path: "/Plumber"
  },
  {
    name: "Pipe Repair",
    path: "/Plumber"
  },
  {
    name: "Water Heater Installation",
    path: "/Plumber"
  },
  {
    name: "Bathroom Renovation Plumbing",
    path: "/Plumber"
  },
  {
    name: "Jet Spray Repair / Replacement",
    path: "/Plumber"
  },
  {
    name: "Toilet Seat Cover Installation",
    path: "/Plumber"
  },
  {
    name: "Flush Tank Repair",
    path: "/Plumber"
  },
  {
    name: "External Flush Tank Replacement",
    path: "/Plumber"
  },
  {
    name: "Indian Toilet Repair / Installation",
    path: "/Plumber"
  },
  {
    name: "Western Toilet Repair (Wall-Mounted)",
    path: "/Plumber"
  },
  {
    name: "Western Toilet Repair (Floor-Mounted)",
    path: "/Plumber"
  },
  {
    name: "Shower Mixer Tap Installation",
    path: "/Plumber"
  },
  {
    name: "Shower Filter Installation",
    path: "/Plumber"
  },
  {
    name: "Shower Repair",
    path: "/Plumber"
  },
  {
    name: "Soap Holder Installation",
    path: "/Plumber"
  },
  {
    name: "Towel Holder Installation",
    path: "/Plumber"
  },
  {
    name: "Shelf Installation",
    path: "/Plumber"
  },
  {
    name: "Wash Basin Leakage Repair",
    path: "/Plumber"
  },
  {
    name: "Waste Coupling Installation",
    path: "/Plumber"
  },
  {
    name: "Drain Cover Installation",
    path: "/Plumber"
  },
  {
    name: "Connection Hose Installation",
    path: "/Plumber"
  },
  {
    name: "Washing Machine Inlet Installation",
    path: "/Plumber"
  },
  {
    name: "RO Water Connection Installation",
    path: "/Plumber"
  },
  {
    name: "Geyser Connection Leakage Repair",
    path: "/Plumber"
  },
  {
    name: "Shut-off Valve Leakage Repair",
    path: "/Plumber"
  },
  {
    name: "Overhead Water Tank Installation",
    path: "/Plumber"
  },
  {
    name: "Water Tank Repair",
    path: "/Plumber"
  },
  {
    name: "Motor Installation",
    path: "/Plumber"
  },
  {
    name: "Motor Air Cavity Removal",
    path: "/Plumber"
  },
  {
    name: "Motor Air Cavity Removal",
    path: "/Plumber"
  },
  {
    name: "Plumber Consultation",
    path: "/Plumber"
  },
  //3rd component
  {
    name: "Split AC installation (2 ACs)",
    path: "/ACMachine"
  },
  {
    name: "Foam-jet service (2 ACs)",
    path: "/ACMachine"
  },
  {
    name: "Foam-jet service",
    path: "/ACMachine"
  },
  {
    name: "General AC service",
    path: "/ACMachine"
  },
  {
    name: "Indoor Coil Deep Cleaning",
    path: "/ACMachine"
  },
  {
    name: "Outdoor Unit Service",
    path: "/ACMachine"
  },
  {
    name: "Low / No Cooling Repair",
    path: "/ACMachine"
  },
  {
    name: "AC Power Issue Repair",
    path: "/ACMachine"
  },
  {
    name: "Water Leakage Repair",
    path: "/ACMachine"
  },
  {
    name: "Gas Refill + Cooling Check",
    path: "/ACMachine"
  },
  {
    name: "PCB / Sensor Repair",
    path: "/ACMachine"
  },
  {
    name: "Noise / Smell Fix",
    path: "/ACMachine"
  },
  {
    name: "Split AC Installation",
    path: "/ACMachine"
  },
  {
    name: "Window AC Installation",
    path: "/ACMachine"
  },
  {
    name: "Split AC Uninstallation",
    path: "/ACMachine"
  },
  {
    name: "Window AC Uninstallation",
    path: "/ACMachine"
  },
  {
    name: "Air Cooler Check-up",
    path: "/ACMachine"
  },
  {
    name: "Motor Air Cavity Removal",
    path: "/ACMachine"
  },
  {
    name: "Foam-Jet Service (3 ACs)",
    path: "/ACMachine"
  },
  {
    name: "Foam-Jet Service (4 ACs)",
    path: "/ACMachine"
  },
  {
    name: "Foam-Jet Service (5 ACs)",
    path: "/ACMachine"
  },
  {
    name: "Window AC Frame Uninstallation",
    path: "/ACMachine"
  },
  {
    name: "AC Repair",
    path: "/ACMachine"
  },
  //4th component
   {
    name: "Full Deep Service (2 Machines)",
    path: "/Washing"
  },
  {
    name: "Jet Cleaning Service (2 Machines)",
    path: "/Washing"
  },
  {
    name: "General Service",
    path: "/Washing"
  },
  {
    name: "Full Deep Cleaning",
    path: "/Washing"
  },
  {
    name: "Machine Not Spinning",
    path: "/Washing"
  },
  {
    name: "Power / Start Problem",
    path: "/Washing"
  },
  {
    name: "Water Leakage Fix",
    path: "/Washing"
  },
  {
    name: "Noise / Vibration Issue",
    path: "/Washing"
  },
  {
    name: "Error Code Repair",
    path: "/Washing"
  },
  {
    name: "Installation",
    path: "/Washing"
  },
  {
    name: "Uninstallation",
    path: "/Washing"
  },
  //5th component
  {
    name: "Single Door Service Pack",
    path: "/Fridge"
  },
  {
    name: "Double Door Service Pack",
    path: "/Fridge"
  },
  {
    name: "Side-by-Side/ French Door Service pack",
    path: "/Fridge"
  },
  {
    name: "General cleaning service",
    path: "/Fridge"
  },
  {
    name: "Premium fridge service",
    path: "/Fridge"
  },
  {
    name: "Fridge not cooling repair",
    path: "/Fridge"
  },
  {
    name: "Power / wiring issue repair",
    path: "/Fridge"
  },
  {
    name: "Water leakage repair",
    path: "/Fridge"
  },
  {
    name: "Noise / vibration repair",
    path: "/Fridge"
  },
  {
    name: "Gas refill (Home fridge)",
    path: "/Fridge"
  },
  {
    name: "Compressor health check",
    path: "/Fridge"
  },
  {
    name: "Thermostat / Sensor Repair",
    path: "/Fridge"
  },
  {
    name: "Deep Freezer Service",
    path: "/Fridge"
  },
  {
    name: "Visi Cooler / Display Fridge",
    path: "/Fridge"
  },
  {
    name: "Commercial Gas Refill",
    path: "/Fridge"
  },
  {
    name: "Commercial Cooling Repair",
    path: "/Fridge"
  },
  //6th component
  {
    name: "Door Repair",
    path: "/Carpenter"
  },
  {
    name: "Door Lock Repair",
    path: "/Carpenter"
  },
  {
    name: "Chair Repair",
    path: "/Carpenter"
  },
  {
    name: "Table Repair",
    path: "/Carpenter"
  },
  {
    name: "Wooden Chair Repair",
    path: "/Carpenter"
  },
  {
    name: "Door Repair",
    path: "/Carpenter"
  },
  {
    name: "Door Installation",
    path: "/Carpenter"
  },
  {
    name: "Cupboard Lock & Latches",
    path: "/Carpenter"
  },
  {
    name: "Drawer Repair and Installation",
    path: "/Carpenter"
  },
  {
    name: "Pull-out Drawer Repair/Replacement",
    path: "/Carpenter"
  },
  {
    name: "Cabinet Hinges",
    path: "/Carpenter"
  },
  {
    name: "Cabinet Hydraulic Repair",
    path: "/Carpenter"
  },
  {
    name: "Utensil Rack Installation",
    path: "/Carpenter"
  },
  {
    name: "Decor Installation",
    path: "/Carpenter"
  },
  {
    name: "Mirror Installation",
    path: "/Carpenter"
  },
  {
    name: "Wall Cabinet Assembly & Installation",
    path: "/Carpenter"
  },
  {
    name: "Bathroom Mirror Cabinet Installation",
    path: "/Carpenter"
  },
  {
    name: "Drill (Per Hole)",
    path: "/Carpenter"
  },
  {
    name: "Soap Holder Installation",
    path: "/Carpenter"
  },
  {
    name: "Towel Holder Installation",
    path: "/Carpenter"
  },
  {
    name: "Door Repair",
    path: "/Carpenter"
  },
  {
    name: "Door Accessories & Mesh Installation",
    path: "/Carpenter"
  },
  {
    name: "Door Close Installation",
    path: "/Carpenter"
  },
  {
    name: "Door Lock Repair & Installation",
    path: "/Carpenter"
  },
  {
    name: "Mosquito Net Installation",
    path: "/Carpenter"
  },
  {
    name: "Blinds Inspection & Measurement (upto 5 ft)",
    path: "/Carpenter"
  },
  {
    name: "Window Accessories",
    path: "/Carpenter"
  },
  {
    name: "Window Misalignment / Jam Repair",
    path: "/Carpenter"
  },
  {
    name: "Curtain Rod Installation",
    path: "/Carpenter"
  },
  {
    name: "Bed Support Repair",
    path: "/Carpenter"
  },
  {
    name: "Headboard Repair",
    path: "/Carpenter"
  },
  {
    name: "Wooden Table Repair",
    path: "/Carpenter"
  },
  {
    name: "Wooden Sofa Repair",
    path: "/Carpenter"
  },
  {
    name: "Ceiling Mounted Hanger Installation",
    path: "/Carpenter"
  },
  {
    name: "Wall Hanger Installation",
    path: "/Carpenter"
  },
  //7th component
  {
    name: "Wireless CCTV installation",
    path: "/Cctv"
  },
  {
    name: "4 Channel 1080P Full HD NVR CPPLUS",
    path: "/Cctv"
  },
  {
    name: "500GB Seagate Hard Disk",
    path: "/Cctv"
  },
  {
    name: "2.4MP Dome & Bullet 3.6mm Cosmic Camera CPPLUS",
    path: "/Cctv"
  },
  {
    name: "CCTV Outdoor Wire 3+1 Black Colour",
    path: "/Cctv"
  },
  {
    name: "4U CCTV Rack",
    path: "/Cctv"
  },
  {
    name: "Power Spike Protector",
    path: "/Cctv"
  },
  {
    name: "4 Channel CCTV Camera Power Supply",
    path: "/Cctv"
  },
  {
    name: "CCTV Camera Installation Service",
    path: "/Cctv"
  },
  //8th comonent
  {
    name: "Air cooler check-up",
    path: "/Cooler"
  },
  {
    name: "Air cooler service",
    path: "/Cooler"
  },
  //9th component
  {
    name: "One Pair Iron",
    path: "/Laundry"
  },
  {
    name: "Dry Wash",
    path: "/Laundry"
  },
  {
    name: "Chemical Wash",
    path: "/Laundry"
  },
  {
    name: "Rolling / Starch",
    path: "/Laundry"
  },
  {
    name: "Stains Wash",
    path: "/Laundry"
  },
  {
  name: "Shirt/Pant/Jeans/T-Shirt/Dhoti Cleaning",
  path: "/Laundry"
},
{
  name: "Shirt/Pant/Jeans/T-Shirt/Dhoti Pressing",
  path: "/Laundry"
},
{
  name: "Pyjama/Capri Cleaning",
  path: "/Laundry"
},
{
  name: "Pyjama/Capri Pressing",
  path: "/Laundry"
},
{
  name: "Achkan/Sherwani Cleaning",
  path: "/Laundry"
},
{
  name: "Achkan/Sherwani Pressing",
  path: "/Laundry"
},
{
  name: "Kurta Cleaning",
  path: "/Laundry"
},
{
  name: "Kurta Pressing",
  path: "/Laundry"
},
{
  name: "Sweat Shirt Cleaning",
  path: "/Laundry"
},
{
  name: "Sweat Shirt Pressing",
  path: "/Laundry"
},
{
  name: "Blazer/Coat Cleaning",
  path: "/Laundry"
},
{
  name: "Blazer/Coat Pressing",
  path: "/Laundry"
},
{
  name: "Jacket Cleaning",
  path: "/Laundry"
},
{
  name: "Jacket Pressing",
  path: "/Laundry"
},
{
  name: "Shirt/Pant/Jeans/T-Shirt Cleaning",
  path: "/Laundry"
},
{
  name: "Shirt/Pant/Jeans/T-Shirt Pressing",
  path: "/Laundry"
},
{
  name: "Shawl Cleaning",
  path: "/Laundry"
},
{
  name: "Shawl Pressing",
  path: "/Laundry"
},
{
  name: "Skirt Cleaning",
  path: "/Laundry"
},
{
  name: "Skirt Pressing",
  path: "/Laundry"
},
{
  name: "Salwar/Capri/Track Pant Cleaning",
  path: "/Laundry"
},
{
  name: "Salwar/Capri/Track Pant Pressing",
  path: "/Laundry"
},
{
  name: "Dress Cleaning",
  path: "/Laundry"
},
{
  name: "Dress Pressing",
  path: "/Laundry"
},
{
  name: "Kurta/Top Cleaning",
  path: "/Laundry"
},
{
  name: "Kurta/Top Pressing",
  path: "/Laundry"
},
{
  name: "Lehnga Cleaning",
  path: "/Laundry"
},
{
  name: "Lehnga Pressing",
  path: "/Laundry"
},
{
  name: "Pyjama/Plazo/Stocking/Legging/Slacks Cleaning",
  path: "/Laundry"
},
{
  name: "Pyjama/Plazo/Stocking/Legging/Slacks Pressing",
  path: "/Laundry"
},
{
  name: "Blouse Cleaning",
  path: "/Laundry"
},
{
  name: "Blouse Pressing",
  path: "/Laundry"
},
{
  name: "Saree Cleaning",
  path: "/Laundry"
},
{
  name: "Saree Pressing",
  path: "/Laundry"
},
{
  name: "Saree Rolling Cleaning",
  path: "/Laundry"
},
{
  name: "Saree Rolling Pressing",
  path: "/Laundry"
},
{
  name: "Saree Polishing Cleaning",
  path: "/Laundry"
},
{
  name: "Saree Polishing Pressing",
  path: "/Laundry"
},
{
  name: "Blanket Single Cleaning",
  path: "/Laundry"
},
{
  name: "Blanket Single Pressing",
  path: "/Laundry"
},
{
  name: "Blanket Double Cleaning",
  path: "/Laundry"
},
{
  name: "Blanket Double Pressing",
  path: "/Laundry"
},
{
  name: "Bedsheet Single Cleaning",
  path: "/Laundry"
},
{
  name: "Bedsheet Single Pressing",
  path: "/Laundry"
},
{
  name: "Bedsheet Double Cleaning",
  path: "/Laundry"
},
{
  name: "Bedsheet Double Pressing",
  path: "/Laundry"
},
{
  name: "Quilt Single Cleaning",
  path: "/Laundry"
},
{
  name: "Quilt Single Pressing",
  path: "/Laundry"
},
{
  name: "Quilt Double Cleaning",
  path: "/Laundry"
},
{
  name: "Quilt Double Pressing",
  path: "/Laundry"
},
{
  name: "Curtain (Single Layer)/Per Panel Cleaning",
  path: "/Laundry"
},
{
  name: "Curtain (Double Layer)/Per Panel Cleaning",
  path: "/Laundry"
},
{
  name: "Carpet (Sq. Ft.) Cleaning",
  path: "/Laundry"
},
{
  name: "Sports Shoes Cleaning",
  path: "/Laundry"
},
{
  name: "Canvas Shoes Cleaning",
  path: "/Laundry"
},
{
  name: "Leather Shoes Cleaning",
  path: "/Laundry"
},
{
  name: "Suede Leather Cleaning",
  path: "/Laundry"
},
{
  name: "Boots Cleaning",
  path: "/Laundry"
},
{
  name: "Slippers Cleaning",
  path: "/Laundry"
},
{
  name: "Sandals Cleaning",
  path: "/Laundry"
}
];

const Search = () => {
  const [query, setQuery] = useState("");
    const navigate = useNavigate();
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().startsWith(query.toLowerCase())
  );
 const handleSelect = (path) => {
    navigate(path);
    setQuery("");
  };
  return (
    <div className="search-container">
      <input
        type="text"
        placeholder="Search for services..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="search-input"
      />

      {query && (
        <div className="suggestions-box">
          {filteredServices.length > 0 ? (
            filteredServices.map((item, index) => (
              <div
                key={index}
                className="suggestion-item"
                onClick={() => handleSelect(item.path)}
              >
                {item.name}
              </div>
            ))
          ) : (
            <div className="no-result">No Results Found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;